import { required } from 'vuelidate/lib/validators';

const file_size_validation = (value, vm) => {
    if (!value) {
        return true;
    }
    let file = value;
    return file.size < 80000000; //80 mb
};

export default {
    validations: {
        file: {
            required,

            fileSize: file_size_validation
        }
    }
};
